import { CheckCircleIcon } from '@mm/icons';
import classnames from 'classnames';
import React from 'react';
import { BillingPlanDefinition } from '../constants';
import { BubbleFeature } from './BubbleFeature/BubbleFeature';
import './PlanCard.pcss';

type Props = {
  plan: BillingPlanDefinition;
  planDetailsOpen: boolean;
  onClick: () => void;
  isSelected?: boolean;
};

export const PlanCard = ({
  plan,
  planDetailsOpen,
  onClick,
  isSelected,
}: Props) => {
  const {
    name,
    price,
    oldPrice,
    featuresList,
    theme,
    bubbleFeatures,
    descriptionText,
  } = plan;
  const classList = classnames('plan-card', `plan-card--theme-${theme}`, {
    'plan-card--selected': isSelected,
  });

  return (
    <div className={classList} onClick={onClick}>
      <div className="plan-card__header">
        <div className="plan-card__header-right-section">
          <div className="plan-card__plan-name">{name}</div>
          {price && <div className="plan-card__price">{price}</div>}
          {oldPrice && <div className="plan-card__price-old">{oldPrice}</div>}
        </div>
      </div>

      {planDetailsOpen && (
        <div className="plan-card__body">
          <div className="plan-card__plan-description">{descriptionText}</div>
          <div className="plan-card__features">
            {featuresList.map((feature: { text: string; isBold?: boolean }) => (
              <div key={feature.text} className="plan-card__feature">
                <CheckCircleIcon className="plan-card__check-icon" />
                <div
                  className={classnames('plan-card__feature-text', {
                    'plan-card__feature-text-bold': feature.isBold,
                  })}
                >
                  {feature.text}
                </div>
              </div>
            ))}
          </div>

          {bubbleFeatures && (
            <div className="plan-card__bubble-features">
              {bubbleFeatures.map(feature => (
                <BubbleFeature key={feature.text} feature={feature} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
